// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__ncMGY","head":"ProcedureTableInfo_head__3bU7e"};